import { InputfieldTypes } from "../../../../../../enums/InputFieldAttributesEnums";

export const dropDownFields = {
  TON_TXT: "Ton",
  LOAD_TXT: "Load",
  HOUR_TXT: "Hour",
};

export const getEditJobFields = ({
  selectMaterialCostAfterFieldProps,
  selectMaterialPriceAfterFieldProps,
  selectTruckingAfterFieldProps,
  selectTruckingPriceAfterFieldProps,
  selectLandedPriceAfterFieldProps,
  handleTruckingPriceCost,
  selectedTruckingPriceUnit,
  onKeyDownHandler,
  onNumericBlur,
}) => {
  return [
    {
      name: "vendorName",
      type: InputfieldTypes.TEXT,
      label: "Vendor",
      disabled: true,
      required: false,
    },
    {
      name: "materialName",
      type: InputfieldTypes.TEXT,
      label: "Material Name",
      disabled: true,
      required: false,
    },
    {
      name: "truckType",
      type: InputfieldTypes.TEXT,
      label: "Truck Type",
      disabled: true,
      required: false,
    },
    {
      name: "quantity",
      type: InputfieldTypes.TEXT,
      label: "Quantity",
      disabled: false,
      required: false,
      onKeyDownHandler: onKeyDownHandler,
      onBlur: onNumericBlur("quantity"),
    },
    {
      name: "materialCost",
      type: InputfieldTypes.TEXT,
      label: "Material Cost",
      disabled: false,
      addonLater: selectMaterialCostAfterFieldProps,
      required: true,
      prefix: "$",
      onKeyDownHandler: onKeyDownHandler,
      onBlur: onNumericBlur("materialCost"),
    },
    {
      name: "materialPrice",
      type: InputfieldTypes.TEXT,
      label: "Material Price",
      disabled: false,
      addonLater: selectMaterialPriceAfterFieldProps,
      required: true,
      prefix: "$",
      onKeyDownHandler: onKeyDownHandler,
      onBlur: onNumericBlur("materialPrice"),
    },
    {
      name: "truckingCost",
      type: InputfieldTypes.TEXT,
      label: "Trucking Cost",
      disabled: false,
      addonLater: selectTruckingAfterFieldProps,
      onBlur: () => handleTruckingPriceCost(false, 1 / 0.875),
      required: true,
      prefix: "$",
      onKeyDownHandler: onKeyDownHandler,
    },
    {
      name: "truckingPrice",
      type: InputfieldTypes.TEXT,
      label: "Trucking Price",
      disabled: false,
      addonLater: selectTruckingPriceAfterFieldProps,
      onBlur: () => handleTruckingPriceCost(true, 0.875),
      required: true,
      prefix: "$",
      onKeyDownHandler: onKeyDownHandler,
    },
    {
      name: "minimumHours",
      type: InputfieldTypes.TEXT,
      label: "Minimum Hours",
      placeholder: "Enter Hours",
      onBlur: onNumericBlur("minimumHours"),
      onKeyDownHandler: onKeyDownHandler,
      disabled: selectedTruckingPriceUnit !== dropDownFields.HOUR_TXT,
    },
    {
      name: "landedPrice",
      type: InputfieldTypes.TEXT,
      label: "Landed Price",
      disabled: true,
      addonLater: selectLandedPriceAfterFieldProps,
      required: false,
      prefix: "$",
    },
  ];
};
